import { CakeBirthdayIcon, IconWrap, Tooltip } from '@libs/ui/ds'
import { usePlanningTranslation } from '@libs/utils/translations'
import { useMemoSelector } from '@spa/redux/hooks'

import { birthdayModalDef } from '../../Modals/BirthdayModal/BirthdayModal'
import { contractsSelectors, usePlanningPolicies } from '../../redux/selectors'
import Corner from '../Corner'

type Props = {
  teamId: number
  day: string
}

export const BirthdayCorner = ({ teamId, day }: Props) => {
  const { t } = usePlanningTranslation()
  const contracts = useMemoSelector(state =>
    contractsSelectors.getBirthdaysByDayAndTeam(state, { teamId, day })
  )
  const { open } = birthdayModalDef.useDispatchModal()
  const { canSeeBirthdays } = usePlanningPolicies()

  if (!contracts.length || !canSeeBirthdays) {
    return null
  }

  return (
    <Corner position='bottomRight' type='none'>
      <Tooltip label={t('common.birthdayTooltipMessage')}>
        <IconWrap
          icon={<CakeBirthdayIcon />}
          size='s'
          onClick={() => open({ contracts, day })}
          className='cursor-pointer'
        />
      </Tooltip>
    </Corner>
  )
}
